const parseMaskedMoney = (value) => {
    if (!value) return 0;
    return parseFloat(value.replace(/[R$\s.]/g, '').replace(',', '.')) || 0;
};

export default parseMaskedMoney;